import { useNavigation, useRoute } from '@react-navigation/native'
import React, { useCallback, useMemo } from 'react'

import { Pressable } from 'widgets/Pressable'

import { useCurrentUser } from 'hooks/useCurrentUser'
import { useDMRoom } from 'hooks/useDMRoom'

import { links } from 'utils/constants'
import { createPartialUser } from 'utils/user/createPartialUser'

import { useFocusMode } from 'contexts/FocusModeContext'

import { UserType } from 'types/user'

import { BaseUserRow, UserRowProps } from './BaseUserRow'

interface PressableUserRowProps extends UserRowProps {
  onUserPress?: (user: UserType) => void
}

export const PressableUserRow = ({
  user,
  sessionsCompletedCount,
  onUserPress,
}: PressableUserRowProps) => {
  const navigation = useNavigation<any>()
  const route = useRoute()
  const { data: currentUser } = useCurrentUser()
  const { createRoom } = useDMRoom({})
  const focusMode = useFocusMode()
  const isFocusMode = useMemo(() => focusMode.group !== undefined, [focusMode.group])

  const createOrUseChatRoomAndNavigate = useCallback(
    async (tempUser: UserType) => {
      if (currentUser && tempUser) {
        const { id: roomId } = await createRoom.mutateAsync({
          participants: [createPartialUser(currentUser), createPartialUser(tempUser)],
        })

        navigation.navigate(links.CHAT_ROOM, { roomId })
      }
    },
    [currentUser, createRoom, navigation],
  )

  const handlePress = async () => {
    if (route.name === links.CHAT_PAGE) {
      await createOrUseChatRoomAndNavigate(user)
    } else {
      navigation.navigate(!isFocusMode ? links.PROFILE_STACK : links.GROUP_STACK, {
        screen: links.MEMBER_PROFILE_PAGE,
        params: { username: user.username },
      })
    }

    if (onUserPress) {
      onUserPress(user)
    }
  }

  return (
    <Pressable testID={`test-${user.username}`} onPress={handlePress}>
      <BaseUserRow user={user} sessionsCompletedCount={sessionsCompletedCount} />
    </Pressable>
  )
}
